@import '../../utils/forced-colors.css';

:host {
  display: block;
  width: 100%;
  box-sizing: border-box;
  -webkit-user-select: none;
  user-select: none;
}

.message-composer {
  display: flex;
  flex-direction: column;
  gap: var(--dimension-space-050);
  width: 100%;
  margin: 0;
}

.message-composer__attachments:empty,
.message-composer__tools:empty,
.message-composer__error-actions:empty {
  display: none;
}

.message-composer__error-support,
.message-composer__error-message,
.message-composer__error-actions {
  display: flex;
  align-items: center;
}

.message-composer__error-support {
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--dimension-space-075) var(--dimension-space-100);
  min-width: 0;
  padding: var(--dimension-space-075) var(--dimension-space-100);
  background: var(--color-background-faint-negative);
}

.message-composer__error-message {
  flex: 1 1 var(--dimension-panel-width-xs);
  gap: var(--dimension-space-050);
  min-width: 0;
  color: var(--color-foreground-bold-negative);
}

.message-composer__error-actions {
  flex: 0 1 auto;
  flex-wrap: wrap;
  gap: var(--dimension-space-050);
}

.message-composer__stack {
  min-width: 0;
}

.message-composer--error .message-composer__stack {
  overflow: hidden;
  border: var(--dimension-stroke-width-012) solid var(--color-border-bold-negative);
  border-radius: var(--dimension-radius-125);
  background: var(--color-background-primary);
  box-shadow: var(--effect-elevation-elevated-md);
}

.message-composer__field {
  display: flex;
  flex-direction: column;
  gap: var(--dimension-space-050);
  padding: var(--dimension-space-100);
  border-radius: var(--dimension-radius-125);
  background: var(--color-background-primary);
  box-shadow: var(--effect-elevation-elevated-md);
  overflow: hidden;
}

.message-composer:not(.message-composer--error) .message-composer__field:focus-within {
  box-shadow: var(--effect-elevation-elevated-md),
    inset 0 0 0 var(--dimension-stroke-width-018) var(--color-border-bold-brand);
}

.message-composer--error .message-composer__field {
  border-radius: 0;
  box-shadow: none;
}

textarea {
  width: 100%;
  min-height: calc(var(--typography-lineheight-md) * 2 + var(--dimension-space-150));
  max-height: calc(var(--typography-lineheight-md) * 6 + var(--dimension-space-150));
  padding: var(--dimension-space-075);
  border: none;
  outline: none;
  resize: none;
  overflow-y: auto;
  box-sizing: border-box;
  background: transparent;
  color: var(--color-foreground-primary);
  font-family: var(--typography-font-family-ui);
  font-size: var(--typography-fontsize-md);
  line-height: var(--typography-lineheight-md);
  font-weight: var(--typography-weight-regular);
  letter-spacing: var(--typography-letterspacing-negative-half);
  -webkit-user-select: text;
  user-select: text;
}

textarea::placeholder {
  color: var(--color-foreground-secondary);
}

textarea:focus::placeholder {
  color: var(--color-foreground-quaternary);
}

textarea:focus,
textarea:focus-visible {
  outline: none;
}

.message-composer__tools {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-050);
  min-height: var(--dimension-size-400);
}

.message-composer__controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--dimension-space-050);
  width: 100%;
  min-width: 0;
}

.message-composer__actions {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-100);
  flex: 0 0 auto;
  margin-inline-start: auto;
}

@media (forced-colors: active) {
  .message-composer__field {
    border: var(--dimension-stroke-width-012) solid var(--ds-forced-color-control-boundary);
    box-shadow: none;
  }

  .message-composer--error .message-composer__field {
    border: 0;
  }

  .message-composer--error .message-composer__stack {
    border: var(--dimension-stroke-width-025) dashed var(--ds-forced-color-content);
    box-shadow: none;
  }

  .message-composer__error-support {
    border-block-end: var(--dimension-stroke-width-012) solid
      var(--ds-forced-color-content);
    background: var(--ds-forced-color-surface);
  }
}
